/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/exhaustive-deps */
import { Button, Form, Input, Modal, Radio, Row, Select, Tag, Upload, notification } from "antd";
import React, { useEffect, useState } from "react";
import { FaUpload } from "react-icons/fa";
import ProductSearch from "./components/ProductSearch";
import { axios, getToken, URL_API } from "../../../../../utils";
import { Panel, PanelBody, PanelHeader } from "../../../../util/panel";

const { TextArea } = Input;

function KnowledgeSourceForm({ history, form, match }) {
  const isEdit = match.params.id !== "add";
  const [loadValue, setLoadValue] = useState(null);
  const [sourceType, setSourceType] = useState("text");
  const [file, setFile] = useState(null);
  const [product, setProduct] = useState(null);

  const {
    getFieldDecorator,
    validateFieldsAndScroll,
    getFieldValue,
    setFieldsValue,
  } = form;

  const loadContent = (id) => {
    axios({
      method: "get",
      baseURL: URL_API,
      url: "/ai/product/knowledge-source/" + id,
      headers: { Authorization: "Bearer " + getToken() },
    })
      .then((res) => {
        const data = res.data;
        setLoadValue(data);
        setSourceType(data.source_type);
        setProduct({ code: data.product_code, name: data.product_name });
        setFieldsValue({
          lang: data.lang,
          raw_content: data.raw_content,
        });
      })
      .catch((err) => {
        notification.error({
          message: "เกิดข้อผิดพลาด",
          description: err && err.response ? err.response.data.message : err.message,
        });
      });
  };

  useEffect(() => {
    if (isEdit) {
      loadContent(match.params.id);
    }
  }, [match.params.id]);

  const handleClickSubmit = () => {
    validateFieldsAndScroll((err, values) => {
      if (err) {
        return notification.warning({
          message: "กรุณาตรวจสอบรายการ",
          description: "กรุณากรอกข้อมูลให้ครบถ้วน",
        });
      }

      if (!isEdit && !product?.code) {
        return notification.warning({
          message: "กรุณาตรวจสอบรายการ",
          description: "กรุณาเลือกสินค้า",
        });
      }

      if (sourceType === "pdf" && !isEdit && !file) {
        return notification.warning({
          message: "กรุณาตรวจสอบรายการ",
          description: "กรุณาเลือกไฟล์ PDF",
        });
      }

      Modal.confirm({
        title: "ยืนยัน",
        content: "ต้องการบันทึกข้อมูลหรือไม่",
        okText: "บันทึก",
        cancelText: "ปิด",
        onOk() {
          return new Promise((resolve, reject) => {
            let requestConfig;

            if (isEdit) {
              requestConfig = {
                method: "post",
                baseURL: URL_API,
                url: `/ai/product/knowledge-source/${match.params.id}`,
                headers: { Authorization: "Bearer " + getToken() },
                data: {
                  raw_content: values.raw_content,
                  lang: values.lang,
                },
              };
            } else if (sourceType === "pdf") {
              const formData = new FormData();
              formData.append("file", file);
              formData.append("product_code", product.code);
              formData.append("lang", values.lang);

              requestConfig = {
                method: "post",
                baseURL: URL_API,
                url: "/ai/product/knowledge-source/upload",
                headers: { Authorization: "Bearer " + getToken() },
                data: formData,
              };
            } else {
              requestConfig = {
                method: "post",
                baseURL: URL_API,
                url: "/ai/product/knowledge-source",
                headers: { Authorization: "Bearer " + getToken() },
                data: {
                  product_code: product.code,
                  lang: values.lang,
                  raw_content: values.raw_content,
                },
              };
            }

            axios(requestConfig)
              .then(() => resolve("success"))
              .catch((error) =>
                reject(
                  error && error.response
                    ? error.response.data.message || error.response.data
                    : error.message
                )
              );
          })
            .then(() => {
              Modal.success({
                title: "สำเร็จ",
                content: "บันทึกเรียบร้อย",
                okText: "ปิด",
                onOk() {
                  history.goBack();
                },
              });
            })
            .catch((reason) => {
              Modal.error({
                title: "ผิดพลาด",
                content: reason,
                okText: "ปิด",
              });
            });
        },
      });
    });
  };

  return (
    <Panel>
      <PanelHeader>ข้อมูลเสริมสินค้าสำหรับ AI</PanelHeader>
      <PanelBody>
        <Form layout="vertical">
          <Form.Item label="สินค้า">
            {isEdit || product?.code ? (
              <Row type="flex" align="middle">
                <Tag color="blue" className="mr-2">
                  {product?.code} {product?.name ? `- ${product.name}` : ""}
                </Tag>
                {!isEdit && (
                  <Button size="small" onClick={() => setProduct(null)}>
                    เปลี่ยนสินค้า
                  </Button>
                )}
              </Row>
            ) : (
              <ProductSearch
                onSelect={(product_code, option) =>
                  setProduct({ code: product_code, name: option?.props.label })
                }
              />
            )}
          </Form.Item>

          <Form.Item label="ภาษา">
            {getFieldDecorator("lang", {
              initialValue: "th",
              rules: [{ required: true, message: "กรุณาเลือกภาษา" }],
            })(
              <Select style={{ width: 200 }}>
                <Select.Option value="th">ไทย</Select.Option>
                <Select.Option value="en">English</Select.Option>
              </Select>
            )}
          </Form.Item>

          {!isEdit && (
            <Form.Item label="ประเภทข้อมูล">
              <Radio.Group
                value={sourceType}
                onChange={(e) => setSourceType(e.target.value)}
              >
                <Radio.Button value="text">พิมพ์ข้อความ (FAQ)</Radio.Button>
                <Radio.Button value="pdf">อัปโหลดไฟล์ PDF</Radio.Button>
              </Radio.Group>
            </Form.Item>
          )}

          {sourceType === "pdf" && !isEdit && (
            <Form.Item label="ไฟล์ PDF">
              <Upload
                accept="application/pdf"
                fileList={file ? [file] : []}
                beforeUpload={(selectedFile) => {
                  setFile(selectedFile);
                  return false;
                }}
                onRemove={() => setFile(null)}
              >
                <Button>
                  <FaUpload className="mr-2" />
                  เลือกไฟล์
                </Button>
              </Upload>
            </Form.Item>
          )}

          {(sourceType === "text" || isEdit) && (
            <Form.Item label="เนื้อหา">
              {getFieldDecorator("raw_content", {
                rules: [{ required: true, message: "กรุณากรอกเนื้อหา" }],
              })(<TextArea rows={8} />)}
            </Form.Item>
          )}

          <Row className="mt-3">
            <Button
              className="bg-nn border-nn text-white mr-3"
              onClick={() => history.goBack()}
            >
              Cancel
            </Button>
            <Button type="primary" onClick={handleClickSubmit}>
              {isEdit ? "Update" : "Save"}
            </Button>
          </Row>
        </Form>
      </PanelBody>
    </Panel>
  );
}

export default Form.create("ai-product-knowledge-source")(KnowledgeSourceForm);
